import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import {
  ReportsEventLabels,
  ReportsEventMap,
  type TrackReportsEvent,
} from './events';

export function useTrackReportsAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackReportsEvent, extra?: Record<string, unknown>) => {
      const eventLabel = ReportsEventLabels[event];
      const eventInfo = ReportsEventMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
